import styled from "styled-components";
import { motion } from "framer-motion";

import { FlexContainer, FlexDiv } from "@/components/Atoms/Box";
import Button from "@/components/Atoms/Button";

import { Typography } from "@/foundation/Typography/V2";

export const StyledFloatingBanner = styled(motion.section)`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  transition: all 0.3s ease-in-out;
  z-index: 1000;
  box-shadow: 0px -4px 20px rgba(${({ theme }) => theme.colors.shadows.black}, 0.02);
  background-color: ${({ theme }) => theme.colorsV2.shyft.purple_text};
`;

export const WrapContainer = styled(FlexContainer)`
  gap: 24px;
  @media only screen and (max-width: 1079px) {
    justify-content: space-between;
    flex-direction: column;
    gap: 0;
  }
`;

export const LHSSection = styled(FlexDiv)`
  width: 100%;
  @media only screen and (max-width: 1079px) {
    margin-bottom: 20px;
  }
`;

export const RHSSection = styled(FlexDiv)`
  width: 100%;
  justify-content: flex-end;
  gap: 16px;
  @media only screen and (max-width: 1079px) {
    justify-content: space-between;
    align-items: center;
  }
`;

export const DownloadButton = styled(motion.div)``;

export const CTAButton = styled(Button)`
  padding: 14px 28px;
  border-radius: 12px;
  width: max-content;
  p {
    font-size: 12px;
    line-height: 20px;
    font-family: var(--man-700);
  }
`;

export const Heading = styled(Typography)`
  color: ${({ theme }) => theme.colors.white};
`;

export const Description = styled(Typography)`
  margin-top: 8px;
  color: ${({ theme }) => theme.colors.white};
`;
